import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {
  CompanyImport,
  CompanyImportResponse,
  JobStatus,
} from '../../../../../../../../../core/model/company-import-text.model';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CompanyImportType } from '../../../../../../../../../core/model/company.model';

@Component({
  selector: 'app-massive-company-unrelated-validation',
  templateUrl: './massive-company-unrelated-validation.component.html',
  styleUrls: ['./massive-company-unrelated-validation.component.scss'],
})
export class MassiveCompanyUnrelatedValidationComponent implements OnChanges {

  @Input() jobStatus!: CompanyImportResponse;
  @Output() formReady = new EventEmitter<UntypedFormGroup>();

  form: UntypedFormGroup;
  JobStatus = JobStatus;

  constructor(
    private _formBuilder: UntypedFormBuilder,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.jobStatus.firstChange && changes.jobStatus && changes.jobStatus.currentValue.status === JobStatus.COMPLETED) {

      this.form = this._formBuilder.group({
        jobId: new UntypedFormControl(this.jobStatus.id),
        relatedCompanies: new UntypedFormArray([]),
      });

      this.getRelatedCompanies().forEach((company: CompanyImport) => {
        this.relatedFormsGroups().push(this.buildCompanyForm(company));
      });

      this.formReady.emit(this.form);
    }
  }

  relatedFormsGroups(): UntypedFormArray {
    return (this.form.get('relatedCompanies') as UntypedFormArray);
  }

  getRelatedCompanyDescription(index: number): string {
    return this.getCompanyDescription(this.getRelatedCompanies()[index]);
  }

  getTitle(): string { //TODO i18n
    return this.jobStatus.parameters.mainCompanyImportType === CompanyImportType.seller ? 'Seller' : 'Debtor';
  }

  private buildCompanyForm(company: CompanyImport): UntypedFormGroup {
    return this._formBuilder.group({
      taxCodePrefix: new UntypedFormControl(company.taxCodePrefix),
      taxCode: new UntypedFormControl(company.taxCode),
      legalRepresentativeFirstName: new UntypedFormControl(company.legalRepresentativeFirstName || null, null),
      legalRepresentativeLastName: new UntypedFormControl(company.legalRepresentativeLastName || null, Validators.required),
      legalRepresentativeEmail: new UntypedFormControl(company.legalRepresentativeEmail || null, [Validators.required, Validators.email]),
      legalRepresentativePhone: new UntypedFormControl(company.legalRepresentativePhone || null, null),
    });
  }

  private getRelatedCompanies(): CompanyImport[] {
    return this.jobStatus.output.relatedCompanies;
  }

  private getCompanyDescription(company: CompanyImport): string {
    return `${company.businessName} (${company.taxCodePrefix} ${company.taxCode})`;
  }
}
